import execute from '../../post';
import { useQuery as useReactQuery, useSuspenseQuery as useSuspenseReactQuery, useQueryClient, useMutation as useReactQueryMutation, } from '@tanstack/react-query';
import { useCallback } from 'react';
/**
 * Returns a query key that should be used with useQuery_escape_hatch.
 *
 * Disclaimer: Do not use this with useInfiniteQuery_escape_hatch, prefer getInfiniteQueryKey_escape_hatch.
 */
export function getQueryKey_escape_hatch(data, options) {
    return [`/api/retailer/find-business-address`, data, options];
}
/**
 * Returns a query key that should be used with useInfiniteQuery_escape_hatch.
 */
export function getInfiniteQueryKey_escape_hatch(data, options) {
    return ['infinite', ...getQueryKey_escape_hatch(data, options)];
}
export function getQueryFn_escape_hatch(data, options) {
    return ({ signal }) => {
        const optionsWithSignal = Object.assign(Object.assign({}, options), { signal });
        return execute(data, optionsWithSignal);
    };
}
export function useQuery_escape_hatch(data, reactQueryOptions, options) {
    return useReactQuery(Object.assign({ queryKey: getQueryKey_escape_hatch(data, options), queryFn: getQueryFn_escape_hatch(data, options) }, reactQueryOptions));
}
export function useSuspenseQuery_escape_hatch(data, suspenseReactQueryOptions, options) {
    return useSuspenseReactQuery(Object.assign({ queryKey: getQueryKey_escape_hatch(data, options), queryFn: getQueryFn_escape_hatch(data, options) }, suspenseReactQueryOptions));
}
export function usePrefetchQuery_escape_hatch() {
    const queryClient = useQueryClient();
    const prefetch = useCallback((data, fetchQueryOptions, options) => {
        return queryClient.prefetchQuery(Object.assign({ queryKey: getQueryKey_escape_hatch(data, options), queryFn: getQueryFn_escape_hatch(data, options) }, fetchQueryOptions));
    }, [queryClient]);
    return prefetch;
}
/**
 * Returns a function that invalidates the query for this endpoint.
 * After being invalidated the query will be refetched on the next useQuery_escape_hatch call.
 */
export function useInvalidateQuery_escape_hatch() {
    const queryClient = useQueryClient();
    const invalidate = useCallback((data, options, invalidateQueryFilters, invalidateOptions) => {
        return queryClient.invalidateQueries(Object.assign({ queryKey: getQueryKey_escape_hatch(data, options) }, invalidateQueryFilters), invalidateOptions);
    }, [queryClient]);
    return invalidate;
}
/**
 * Returns a function that invalidates the infinite query for this endpoint.
 * After being invalidated the query will be refetched on the next useInfiniteQuery_escape_hatch call.
 */
export function useInvalidateInfiniteQuery_escape_hatch() {
    const queryClient = useQueryClient();
    const invalidate = useCallback((data, options, invalidateQueryFilters, invalidateOptions) => {
        return queryClient.invalidateQueries(Object.assign({ queryKey: getInfiniteQueryKey_escape_hatch(data, options) }, invalidateQueryFilters), invalidateOptions);
    }, [queryClient]);
    return invalidate;
}
export function useMutation(reactQueryOptions) {
    return useReactQueryMutation(Object.assign({ mutationFn: (params) => execute(...params) }, reactQueryOptions));
}
